export default {
    "name": "TeardownScreen",
    "kind": "HoudiniQuery",
    "hash": "3da405e22f9b00b61fa802423352587458de5bbd95d2e21d71155d2b5fc08791",

    "raw": `query TeardownScreen($vehicleId: Int!, $storeId: UInt!) {
  vehicle(id: $vehicleId) {
    id
    storeId
    status
    wholeUnit {
      inventoryType {
        breakdownTemplates {
          id
          name
          default
          components {
            inventoryTypeId
            quantity
            rank
            integral
          }
        }
        id
      }
      id
    }
    inventories {
      innodbInventoryid: id
      inventoryId
      storeId
      tagNumber
      status
      inventoryTypeId
      retailPrice
      cost
      manufacturer {
        name
        id
      }
      model {
        name
        id
      }
      id
    }
  }
  inventoryTypes {
    id
    name
    active
  }
  frequentlyUsedInventoryTypes: inventoryTypesFrequentlyUsed(storeId: $storeId) {
    id
    name
  }
  session {
    fieldAccess {
      inventory {
        cost {
          read
        }
      }
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "vehicle": {
                "type": "Vehicle",
                "keyRaw": "vehicle(id: $vehicleId)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "storeId": {
                            "type": "UInt",
                            "keyRaw": "storeId",
                            "visible": true
                        },

                        "status": {
                            "type": "StatusEnum",
                            "keyRaw": "status",
                            "visible": true
                        },

                        "wholeUnit": {
                            "type": "Inventory",
                            "keyRaw": "wholeUnit",

                            "selection": {
                                "fields": {
                                    "inventoryType": {
                                        "type": "InventoryType",
                                        "keyRaw": "inventoryType",

                                        "selection": {
                                            "fields": {
                                                "breakdownTemplates": {
                                                    "type": "BreakdownTemplate",
                                                    "keyRaw": "breakdownTemplates",

                                                    "selection": {
                                                        "fields": {
                                                            "id": {
                                                                "type": "UInt",
                                                                "keyRaw": "id",
                                                                "visible": true
                                                            },

                                                            "name": {
                                                                "type": "String",
                                                                "keyRaw": "name",
                                                                "nullable": true,
                                                                "visible": true
                                                            },

                                                            "default": {
                                                                "type": "Boolean",
                                                                "keyRaw": "default",
                                                                "visible": true
                                                            },

                                                            "components": {
                                                                "type": "BreakdownTemplateComponent",
                                                                "keyRaw": "components",

                                                                "selection": {
                                                                    "fields": {
                                                                        "inventoryTypeId": {
                                                                            "type": "UInt",
                                                                            "keyRaw": "inventoryTypeId",
                                                                            "visible": true
                                                                        },

                                                                        "quantity": {
                                                                            "type": "Decimal6",
                                                                            "keyRaw": "quantity",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        },

                                                                        "rank": {
                                                                            "type": "Int",
                                                                            "keyRaw": "rank",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        },

                                                                        "integral": {
                                                                            "type": "Boolean",
                                                                            "keyRaw": "integral",
                                                                            "nullable": true,
                                                                            "visible": true
                                                                        }
                                                                    }
                                                                },

                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "inventories": {
                            "type": "Inventory",
                            "keyRaw": "inventories",

                            "selection": {
                                "fields": {
                                    "innodbInventoryid": {
                                        "type": "UInt",
                                        "keyRaw": "innodbInventoryid",
                                        "visible": true
                                    },

                                    "inventoryId": {
                                        "type": "Int",
                                        "keyRaw": "inventoryId",
                                        "visible": true
                                    },

                                    "storeId": {
                                        "type": "UInt",
                                        "keyRaw": "storeId",
                                        "visible": true
                                    },

                                    "tagNumber": {
                                        "type": "String",
                                        "keyRaw": "tagNumber",
                                        "visible": true
                                    },

                                    "status": {
                                        "type": "StatusEnum",
                                        "keyRaw": "status",
                                        "visible": true
                                    },

                                    "inventoryTypeId": {
                                        "type": "UInt",
                                        "keyRaw": "inventoryTypeId",
                                        "visible": true
                                    },

                                    "retailPrice": {
                                        "type": "Decimal2",
                                        "keyRaw": "retailPrice",
                                        "visible": true
                                    },

                                    "cost": {
                                        "type": "Decimal2",
                                        "keyRaw": "cost",
                                        "visible": true
                                    },

                                    "manufacturer": {
                                        "type": "Manufacturer",
                                        "keyRaw": "manufacturer",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "UInt",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "model": {
                                        "type": "Model",
                                        "keyRaw": "model",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "name": {
                                                    "type": "String",
                                                    "keyRaw": "name",
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "Int",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "inventoryTypes": {
                "type": "InventoryType",
                "keyRaw": "inventoryTypes",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "active": {
                            "type": "Boolean",
                            "keyRaw": "active",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "frequentlyUsedInventoryTypes": {
                "type": "InventoryType",
                "keyRaw": "frequentlyUsedInventoryTypes(storeId: $storeId)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "session": {
                "type": "Session",
                "keyRaw": "session",

                "selection": {
                    "fields": {
                        "fieldAccess": {
                            "type": "FieldAccess",
                            "keyRaw": "fieldAccess",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "inventory": {
                                        "type": "InventoryPermissions",
                                        "keyRaw": "inventory",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "cost": {
                                                    "type": "FieldPermissions",
                                                    "keyRaw": "cost",
                                                    "nullable": true,

                                                    "selection": {
                                                        "fields": {
                                                            "read": {
                                                                "type": "Boolean",
                                                                "keyRaw": "read",
                                                                "nullable": true,
                                                                "visible": true
                                                            }
                                                        }
                                                    },

                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "vehicleId": "Int",
            "storeId": "UInt"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=f660d0f73c376f398a78b12ee71ac8ed3dc69e160f71903278ce639e74b7205f";